<template>
  <v-app>
    <div id="main" v-resize="setIsMobile">
      <div id="main-left" v-if="!isLoginPage">
        <SideMenu v-if="!isLoginPage"/>
      </div>
      <div id="main-right">
        <Banner v-if="!isLoginPage" />
        <div id="content">
          <div
              style="width:60px;cursor:pointer;margin-left:10px;margin-top:5px"
              @click="$router.back()"
              v-if="!isLoginPage && $route.path !== '/home'"
          >
            <v-icon small>mdi-arrow-left-bold</v-icon>
            <span style="position:relative;top:1px;color:#223773;font-weight:bold;font-size:14px">
              BACK
            </span>
          </div>
          <router-view />
        </div>
      </div>
    </div>

    <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
        :background-color="'#000'"
        :opacity="0.5"
        :color="'#c92127'"
        :lock-scroll="true"
        :loader="'dots'"
        :blur="'0px'"
    />

    <Notification
        v-if="$store.state.notification"
        @close="$store.state.notification = false"
    />
  </v-app>
</template>

<script>
import Firebase from 'firebase/app';
import Banner from './components/Banner';
import SideMenu from './components/SideMenu';
import Notification from './components/Notification.vue';
import { mapGetters, mapActions } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'App',
  components: { Banner, SideMenu, Notification, Loading },
  computed: {
    ...mapGetters({
      isLoading: 'isLoading',
      current_user: 'current_user',
    }),
    isLoginPage() {
      return this.$route.path === '/';
    },
  },
  watch: {
    current_user(val) {
      if (val === null) {
        Firebase.auth().signOut().then(() => {
          this.$router.push('/login');
        });
      }
    },
  },
  mounted() {
    Firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.retrieveDatabaseSnapshot(user.uid);
        if (this.$route.path === '/login' || this.$route.path === '/') {
          this.$router.push('/home');
        }
      }
    });
  },
  methods: {
    ...mapActions(['retrieveDatabaseSnapshot', 'setIsMobile']),
  },
};
</script>

<style lang="scss">
@import 'styles/global.scss';

body,
html {
  overflow: hidden;
}

#app {
  overflow: hidden;
  background: #e8e8e8;
}

#main {
  display: table;
  height: 100%;
}

#main-left {
  display: table-cell;
  width: 50px;
  height: 100%;
}

#main-right {
  display: table-cell;
  height: 100%;
  vertical-align: top;
}

#content {
  height: calc(100vh - 55px);
  overflow-y: auto;
}
</style>
